import React from "react";
import { useFormContext } from "react-hook-form";

import { FormFieldStatus, Input } from "../../elements";
import { AddressFormFields, AddressFormFieldsProps } from "../address-form-fields";
import {
  BusinessRelationshipFormFields,
  BusinessRelationshipFormFieldsProps,
} from "../buisness-relationship-form-fields";
import { emailRegex, phoneRegex } from "../constants";
import { MaterialsApiFormFields, MaterialsApiFormFieldsProps } from "../materials-api-form-fields";
import { PersonalAreaProfileFormFieldsLabels, PersonalAreaProfileFormFieldsTypes } from "./types";

export interface PersonalAreaProfileFormFieldsProps {
  labels: PersonalAreaProfileFormFieldsLabels;
  countriesList: AddressFormFieldsProps["countriesList"];
  statesList: AddressFormFieldsProps["statesList"];
  businessRelationshipList: BusinessRelationshipFormFieldsProps["optionsList"];
  materialsList: MaterialsApiFormFieldsProps["optionsList"];
}

export function PersonalAreaProfileFormFields({
  labels,
  countriesList,
  businessRelationshipList,
  materialsList,
  statesList,
}: PersonalAreaProfileFormFieldsProps) {
  const formMethods = useFormContext<PersonalAreaProfileFormFieldsTypes>();
  const { errors } = formMethods.formState;

  return (
    <div className="grid gap-x-5 gap-y-8 grid-cols-1 lg:grid-cols-2 w-full">
      <Input
        label={labels.firstName}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("firstName", { required: labels.requiredFieldMessage })}
        message={errors.firstName?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        label={labels.lastName}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("lastName", { required: labels.requiredFieldMessage })}
        message={errors.lastName?.message}
        status={FormFieldStatus.Error}
      />

      <Input
        label={labels.email}
        {...formMethods?.register("email", {
          pattern: {
            value: emailRegex,
            message: labels.wrongEmailFormat,
          },
        })}
        message={errors.email?.message}
        status={FormFieldStatus.Error}
        readOnly
      />

      <Input
        label={labels.phone}
        {...formMethods?.register("phone", {
          pattern: {
            value: phoneRegex,
            message: labels.wrongPhoneFormat,
          },
        })}
        message={errors.phone?.message}
        status={FormFieldStatus.Error}
      />

      <BusinessRelationshipFormFields labels={labels} optionsList={businessRelationshipList} />

      <Input
        className="lg:col-span-2"
        label={labels.company}
        required
        optionalLabel={labels.optionalLabel}
        {...formMethods?.register("company", { required: labels.requiredFieldMessage })}
        message={errors.company?.message}
        status={FormFieldStatus.Error}
      />

      <AddressFormFields
        labels={labels}
        className="lg:col-span-2"
        countriesList={countriesList}
        statesList={statesList}
      />

      <MaterialsApiFormFields
        labels={labels}
        className="lg:col-span-2"
        optionsList={materialsList}
      />
    </div>
  );
}
